import { ItemCombobox } from '@models-global/model-combobox-item';

export enum AuditCustomerType {
  MANUFACTURER = 0,
  PAYER = 1,
  PBM = 2
}

export const MAP_AUDIT_CUSTOMER_TYPE = {
  [AuditCustomerType.MANUFACTURER]: 'Manufacturer',
  [AuditCustomerType.PAYER]: 'Payer',
  [AuditCustomerType.PBM]: 'PBM'
};

export const ARRAY_AUDIT_CUSTOMER_TYPE: ReadonlyArray<ItemCombobox> = [
  {
    value: AuditCustomerType.PBM,
    text: MAP_AUDIT_CUSTOMER_TYPE[AuditCustomerType.PBM]
  },
  {
    value: AuditCustomerType.PAYER,
    text: MAP_AUDIT_CUSTOMER_TYPE[AuditCustomerType.PAYER]
  },
  {
    value: AuditCustomerType.MANUFACTURER,
    text: MAP_AUDIT_CUSTOMER_TYPE[AuditCustomerType.MANUFACTURER]
  }
];
